export const certificateHero = {
  title: '修了証・認定資格について',
  titleEn: 'CERTIFICATION',
  lead: '各コース修了時の実技試験に合格すると、協会認定資格を取得できます。',
};

export const certificationLevels = [
  {
    id: 'associate',
    level: '01',
    name: '認定アソシエイトバトラー',
    nameEn: 'Certified Associate Butler',
    course: 'エッセンシャルコース',
    courseHref: '/courses/essential',
    lead: '執事としての基礎的な知識と技能を身につけたことを証明する、初級の認定資格です。テーブルマナー、基本的なサービス作法、衣類ケアの基礎を習得していることを示します。',
    skills: ['テーブルマナー基礎', '基本的なサービス作法', '衣類ケア入門', 'コミュニケーション基礎'],
  },
  {
    id: 'professional',
    level: '02',
    name: '認定プロフェッショナルバトラー',
    nameEn: 'Certified Professional Butler',
    course: 'アドバンスコース',
    courseHref: '/courses/advanced',
    lead: 'より高度なサービス技能とホスピタリティマネジメント能力を備えたことを証明する、中級の認定資格です。ワインサービスやイベント運営まで、実践的な専門性を示します。',
    skills: ['ワイン・ティーサービス', 'イベント設営・運営', '高度なテーブルコーディネート', '来客対応プロトコル'],
  },
  {
    id: 'master',
    level: '03',
    name: '認定マスターバトラー',
    nameEn: 'Certified Master Butler',
    course: 'マスターコース',
    courseHref: '/courses/master',
    lead: '執事としての総合的な専門性とマネジメント能力を極めたことを証明する、最上級の認定資格です。ハウスホールドマネジメントからスタッフ統括、コンサルテーションまで、プロフェッショナルに必要な全領域を網羅していることを示します。',
    skills: ['ハウスホールドマネジメント', 'スタッフ統括・指導法', 'コンサルテーション技法', '執事業務の総合実践'],
  },
];

export const requirements = {
  title: '資格取得の条件',
  titleEn: 'REQUIREMENTS',
  lead: '資格の取得には、一定の出席に加え、筆記試験と実技試験の合格が必要です。学びの成果を、確かな基準で評価します。',
  items: [
    {
      icon: 'ri-calendar-check-line',
      label: '出席率 80%以上',
      description: '各コースの全日程のうち、80%以上の出席が必須です。やむを得ない欠席がある場合は、補講または次期開催での振替受講（有料）が可能です。',
    },
    {
      icon: 'ri-file-text-line',
      label: '筆記試験の合格',
      description: '各コース修了時に、学習内容を問う筆記試験を実施します。教科書および講義内容から出題し、合格基準点は70点以上（100点満点）です。',
    },
    {
      icon: 'ri-service-line',
      label: '修了実技試験の合格',
      description: '実際の執事業務を想定した実技試験です。所作・手順・対応力を、複数の評価者が定められた基準に基づき評価します。',
    },
  ],
  retakeNote: '実技試験に不合格の場合、次期開催時に1回まで無料で再試験を受験できます。それ以降は再試験料として11,000円（税込）を申し受けます。',
};

export const examOverview = {
  title: '修了実技試験の概要',
  titleEn: 'PRACTICAL EXAMINATION',
  lead: '実技試験は、学んだ技能を実際の場面で発揮できるかを確認する場です。試験内容はコースごとに設定されており、段階的に高度になります。',
  exams: [
    {
      course: 'エッセンシャルコース',
      courseEn: 'ESSENTIAL',
      content: 'テーブルセッティングとティーサービスの実演',
      description: '正しいテーブルセッティングの手順、ティーサービスの一連の所作を実演していただきます。基本的な動作の正確さと、所作の美しさを評価します。',
      icon: 'ri-cup-line',
    },
    {
      course: 'アドバンスコース',
      courseEn: 'ADVANCED',
      content: 'フォーマルディナーとワインサービス',
      description: 'フォーマルディナーのテーブルセッティングから、ワインの温度管理・抜栓・注酒までの一連のサービスを実演していただきます。',
      icon: 'ri-goblet-line',
    },
    {
      course: 'マスターコース',
      courseEn: 'MASTER',
      content: '卒業ディナー実技（フォーマル晩餐会）',
      description: 'フォーマル晩餐会の企画・設営からサービスまでを総合的に実演していただきます。スタッフの統括や、予期せぬ状況への対応力も評価対象です。',
      icon: 'ri-vip-crown-line',
    },
  ],
};

export const awardItems = {
  title: '合格者に授与されるもの',
  titleEn: 'WHAT YOU RECEIVE',
  lead: '修了実技試験に合格された方には、以下の品を授与します。いずれも、習得した技能を対外的に証明する公式なものです。',
  items: [
    {
      name: '認定証',
      description: '一般社団法人全日本執事協会が発行する公式の認定証。認定資格名・認定番号・取得日を記載します。',
      icon: 'ri-file-text-line',
    },
    {
      name: '認定ピンバッジ',
      description: '認定級に応じたデザインのピンバッジ。実務の場で身につけられる、資格の証です。',
      icon: 'ri-medal-line',
    },
    {
      name: '認定番号',
      description: '認定者ごとに付与される固有の番号。協会の認定者名簿に登録され、資格の真正性を確認できます。',
      icon: 'ri-fingerprint-line',
    },
    {
      name: 'デジタル認定証（PDF）',
      description: '印刷用のデジタル認定証をPDFで発行します。履歴書への添付やSNS等でのご活用が可能です（ご希望の方のみ）。',
      icon: 'ri-smartphone-line',
    },
  ],
  rosterNote: '認定者名簿への掲載は同意制です。個人情報の取り扱いについては、プライバシーポリシーに従います。',
};

export const usageSection = {
  title: '資格の活用',
  titleEn: 'HOW TO USE',
  lead: '認定資格は、執事としての専門性を客観的に示すものです。就職・転職時のスキル証明としてご活用いただけます。修了生向けの求人情報提供の仕組みも準備を進めており、キャリア形成を支援します。',
  points: [
    {
      icon: 'ri-briefcase-line',
      title: '就職・転職時のスキル証明',
      description: '認定証および認定ピンバッジは、執事としての技能水準を第三者に示す客観的な証明書類としてご活用いただけます。',
    },
    {
      icon: 'ri-folder-user-line',
      title: '求人情報へのアクセス（準備中）',
      description: '修了生向けに、協会が把握した執事関連の求人情報を提供する仕組みを予定しています。キャリアの選択肢を広げる情報提供として整備を進めています。',
    },
    {
      icon: 'ri-building-2-line',
      title: '信頼性の証明',
      description: '協会認定資格は、雇用主やクライアントに対し、一定水準以上の技能を有することを示す信頼の指標となります。',
    },
  ],
  note: '※認定資格は、就職を保証するものではありません。あくまで技能水準を証明するものであり、就職活動はご自身で行っていただきます。',
};

export const certificateFaqs = [
  {
    question: 'どんな資格が取得できますか?',
    answer: 'コースに応じて認定アソシエイト/プロフェッショナル/マスターバトラーの3階級があります。修了実技試験の合格者に授与します。',
  },
  {
    question: '国家資格ですか?',
    answer: 'いいえ。一般社団法人全日本執事協会が独自に認定する民間資格です。',
  },
  {
    question: '試験に落ちたらどうなりますか?',
    answer: '次期開催時に1回まで無料で再試験を受けられます。それ以降は再試験料（11,000円税込）を申し受けます。',
  },
];

export const certificateRelatedPages = [
  {
    title: '受講特典',
    description: '実務で使える受講特典',
    href: '/benefits',
  },
  {
    title: 'コース一覧・比較',
    description: '3コースの違いを一覧で確認',
    href: '/courses',
  },
  {
    title: '習得スキル一覧',
    description: '身につく5つのスキル領域',
    href: '/skills',
  },
  {
    title: '全日本執事協会について',
    description: '運営母体と提供する事業',
    href: '/association',
  },
];